import React from 'react';

const NoTrace = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
      <g fill="none" fillRule="evenodd">
        <g fill="#FFF">
          <g>
            <g>
              <g>
                <path
                  d="M19.96 22.906c-1.507 0-2.728-1.221-2.728-2.726 0-1.507 1.22-2.728 2.727-2.728s2.728 1.22 2.728 2.728c0 1.505-1.221 2.726-2.728 2.726m2.032 13.579c-.593 0-1.197-.022-1.817-.066-9.26-.649-14.256-7.61-14.256-13.831 0-3.352 1.306-6.505 3.677-8.875 2.372-2.372 5.525-3.677 8.878-3.677 3.354 0 6.506 1.305 8.879 3.677.63.63.63 1.65 0 2.28-.63.632-1.653.632-2.283.002-1.762-1.762-4.104-2.732-6.596-2.732s-4.833.97-6.596 2.73c-1.762 1.762-2.732 4.105-2.732 6.595 0 4.762 3.945 10.1 11.255 10.612 9.13.64 14.489-4.147 19.6-10.59V6.206C40 2.793 37.207 0 33.793 0H6.206C2.793 0 0 2.793 0 6.207v6.204c4.912-5.408 10.843-9.462 19.825-8.83 9.26.648 14.257 7.61 14.257 13.831 0 3.352-1.306 6.506-3.678 8.876-2.371 2.37-5.524 3.677-8.877 3.677-3.353 0-6.506-1.306-8.878-3.677-.63-.63-.63-1.65 0-2.282.63-.63 1.651-.63 2.28 0 1.764 1.762 4.106 2.73 6.598 2.73 2.491 0 4.833-.968 6.596-2.73 1.762-1.762 2.732-4.103 2.732-6.594 0-4.762-3.945-10.1-11.255-10.613C10.477 6.16 5.114 10.947 0 17.392v16.4C0 37.206 2.793 40 6.206 40h27.587C37.207 40 40 37.206 40 33.792v-6.204c-4.571 5.035-10.026 8.897-18.01 8.897"
                  transform="translate(-16 -4528) translate(0 4078) translate(16 450) translate(1 1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default NoTrace;
